import type { ReactNode } from "react";
import {
  FieldHelp,
  type FieldHelpContent,
} from "@/components/ui/field-help";
import { cn } from "@/lib/utils";

/** Labeled values for View mode — not fake disabled inputs (plan/40). */
export function DetailReadout(props: {
  rows: readonly {
    label: string;
    value: ReactNode;
    mono?: boolean;
    /** Sparse “?” — plan/46. */
    help?: FieldHelpContent;
  }[];
  className?: string;
}) {
  return (
    <dl className={cn("mt-4 space-y-3", props.className)}>
      {props.rows.map((row) => (
        <div key={row.label}>
          <dt className="inline-flex items-center text-sm text-[var(--color-muted)]">
            {row.label}
            {row.help ? <FieldHelp content={row.help} /> : null}
          </dt>
          <dd
            className={cn(
              "mt-0.5 text-sm text-[var(--color-foreground)]",
              row.mono && "font-mono",
            )}
          >
            {row.value === "" || row.value == null ? (
              <span className="text-[var(--color-muted)]">—</span>
            ) : (
              row.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
